// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload-document-container {\n  padding: 10px;\n  overflow: auto;\n  max-height: 255px;\n}\n", "",{"version":3,"sources":["webpack://src/pages/uploadDocuments/UploadDocuments.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".upload-document-container {\n  padding: 10px;\n  overflow: auto;\n  max-height: 255px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
